import { useLazyQuery } from "@apollo/client";
import { useState, useCallback } from "react";
import {
  LocationDetailsDocument,
  LocationDetails,
} from "../../__generated__/graphql";

export default function useLocationDetails() {
  const [locationDetails, setLocationDetails] =
    useState<LocationDetails | null>(null);

  const [getLocationDetailsQuery, { loading, error }] = useLazyQuery(
    LocationDetailsDocument,
    {
      onCompleted: (data) => {
        setLocationDetails(data?.locationDetails || null);
      },
      onError: (error) => {
        console.error("Location details error:", error);
        setLocationDetails(null);
      },
    }
  );

  const getLocationDetails = useCallback(
    (placeId: string) => {
      getLocationDetailsQuery({
        variables: {
          locationDetailsInput: {
            placeId,
          },
        },
      });
    },
    [getLocationDetailsQuery]
  );

  const clearLocationDetails = useCallback(() => {
    setLocationDetails(null);
  }, []);

  return {
    getLocationDetails,
    locationDetails,
    loading,
    error,
    clearLocationDetails,
  };
}
